import React, { useEffect, useState } from "react";

interface ITimerProps {
  status: number;
}

function Timer({ status }: ITimerProps) {
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");
  const [day, setDay] = useState("");
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toString().split(" ")[4].substring(0, 5));
      setDate(`${new Date().getMonth() + 1} / ${new Date().getDate()}`);
      setDay(`周${"日一二三四五六".charAt(new Date().getDay())}`);
    }, 1000);
    return () => {
      if (timer) clearInterval(timer);
    };
  }, []);

  return (
    <div className={`timer status-${status}`}>
      <div
        className="status-0-part"
      >
        <div
          style={{
            fontSize: "10vw",
          }}
        >
          {time}
        </div>
        <div
          style={{
            fontSize: "5vw",
            opacity: 0.7,
          }}
        >
          <div>{day}</div>
          <div>{date}</div>
        </div>
      </div>
      <div
        className="status-1-part"
      >
        <div
          style={{
            fontSize: "14vw",
          }}
        >
          {time}
        </div>
        <div
          style={{
            fontSize: "5vw",
          }}
        >
          <div>
            {date}&nbsp;
            {day}
          </div>
        </div>
      </div>
      <div
        className="status-2-part"
      >
        <div
          style={{
            fontSize: "14vw",
          }}
        >
          {time}
        </div>
        <div
          style={{
            fontSize: "5vw",
          }}
        >
          <div>
            {date}&nbsp;
            {day}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Timer;
